// Despesas Financeiras (Gestão Orçamentária): mesma hierarquia de categoria/item (e mesma
// lógica de inflação/reajuste) de Custos Gerais, mas geral — não escopada por departamento
// real da empresa (mesma visão executiva de Faturamento Bruto / Novas Vendas).
// Espelha backend/config.py ROLES_DESPESAS_FINANCEIRAS — mantenha os dois em sincronia.
export const ROLES_DESPESAS_FINANCEIRAS = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO"];
